import React from 'react';
import FormField from './FormField';

const WizardStep = ({ 
  company,
  step, 
  handleInputChange, 
  errors, 
}) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-2xl font-bold mb-4">{step.label}</h2>
      {step.description && <p className="text-gray-600 mb-6">{step.description}</p>}
      
      {step.fields.map((field) => (
        <FormField
          company={company}
          key={field.id}
          field={field}
          handleInputChange={handleInputChange}
          error={errors[field.id]}
        />
      ))}
    </div>
  );
};

export default WizardStep;